module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "contain"
  }, [(_vm.id == 6) ? _c('div', [_c('link-c')], 1) : _vm._e(), _vm._v(" "), (_vm.id == 'reg') ? _c('div', [_c('register')], 1) : _vm._e(), _vm._v(" "), (_vm.id == 'reset') ? _c('div', [_c('resetpass')], 1) : _vm._e(), _vm._v(" "), (_vm.id == 'login_cn') ? _c('div', [_c('login')], 1) : _vm._e(), _vm._v(" "), (_vm.id == 316) ? _c('div', [_c('ims')], 1) : _vm._e(), _vm._v(" "), (_vm.id != 6 && _vm.id !== 'reg' && _vm.id !== 'login') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.delHtml)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c45d5da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/temp_view_cn.vue
// module id = 811
// module chunks = 10